module.exports = __webpack_public_path__ + "media/images/client-mathnasium-2d8f87ab6366b7844b57d4169d7817c3.png";